export default class Automation {

    constructor(Rest) {
        this.rest = Rest.rest;
    }

    typeIdToString(messageTypeId) {
        return messageTypeId == 1 ? 'email' : 'textMessage';
    };

    find(id) {
        return this.rest.one('automail', id).get();
    };

    updateName(id, name) {
        return this.rest.one('automail', id).put({ name });
    };

    all(active, page) {
        page = page || 1;
        return this.rest.one('automail').get({
            active: active,
            page: page,
            paginate: true,
            'includes[]': [ 'trigger', 'messages', 'messages.subscribers_counter', 'messages_counter' ]
        });
    };

    // deprecated
    statusCounts() {
        return this.rest.one('automail').one('status-counts').get();
    };
    
    search(query) {
        return this.rest.all('automation/search').post({ query: query });
    };

    create() {
        return this.rest.all('automail').post();
    }

    store(name) {
        return this.rest.all('automail').post({name: name})
    };

    // deprecated
    subscriberPendingMessageCount(automationId) {
        return this.rest.one('automation', automationId).one('countSubscribersPending').get();
    };

    remove(id) {
        return this.rest.one('automail', id).remove()
    };

    update(id, attributes) {
        return this.rest.one('automail', id).put(attributes)
    };

    activate(id) {
        return this.rest.one('automail', id).one('activate').post()
    };

    deactivate(id) {
        return this.rest.one('automail', id).one('deactivate').post()
    };

    findEmail(id, emailId) {
        return this.rest.one('automail', id).one('message', emailId).get({ message_type: 'email' });
    };

    activateMessage(id, messageId, messageTypeId) {
        return this.rest.all('automation/' + id + '/message/' + messageId + '/activate').post({ message_type: this.typeIdToString(messageTypeId) });
    };

    deactivateMessage(id, messageId, messageTypeId) {
        return this.rest.all('automation/' + id + '/message/' + messageId + '/deactivate').post({ message_type: this.typeIdToString(messageTypeId) });
    };

    findTextMessage(id, textMessageId) {
        return this.rest.one('automail', id).one('message', textMessageId).get({ message_type: 'textMessage' });
    };

    removeMessage(id, messageId, messageTypeId) {
        return this.rest.one('automail', id).one('message', messageId).remove({ message_type: this.typeIdToString(messageTypeId) });
    };

    activateTextMessage(id, textMessageId) {
        return this.rest.one('automail/' + id + '/message/' + textMessageId + '/type/2/activate').post();
    };

    deactivateTextMessage(id, textMessageId) {
        return this.rest.one('automail/' + id + '/message/' + textMessageId + '/type/2/deactivate').post();
    };

    setMessageDelay(id, messageId, delayInSeconds, messageTypeId) {
        return this.rest.all('automation/' + id + '/message/' + messageId + '/delay').post({
            delay_in_seconds: delayInSeconds,
            message_type: this.typeIdToString(messageTypeId)
        });
    };

    getHistoryMeta(id, emailId) {
        return this.rest.one('automail', id).one('message', emailId).one('history').get({ message_type: 'email' });
    };

    getTextMessageHistoryMeta(id, textMessageId) {
        return this.rest.one('automail', id).one('message', textMessageId).one('history').get({ message_type: 'textMessage' });
    };

    getTextMessageHistoryContent(contentId) {
        return this.rest.one('automail/textMessage/historicalContent', contentId).get();
    };

    addTrigger(id, triggerId, triggerType) {
        return this.rest.all('automation/' + id + '/trigger').post({triggerId: triggerId, triggerType: triggerType});
    };

    destroyTag(id) {
        return this.rest.one('automail/' + id + '/tag').remove()
    };

    destroySegment(id) {
        return this.rest.one('automail/' + id + '/segment').remove()
    };

    setCustomMessageTrigger(automationId, messageId, messageTypeId, segmentId) {
        return this.rest.all('automation/' + automationId + '/message/' + messageId + '/setCustomMessageTrigger').post({
            messageTypeId: messageTypeId,
            segmentId: segmentId
        });
    };

    getEmailSentCount(emailid) {
        return this.rest.one('automail').one('email', emailid).one('sent').get();
    };

    saveEmail(id, email) {
        return this.rest.one('automail', id).one('email', email.id).customPUT({ email: email });
    };

    saveTextMessage(id, textMessage) {
        return this.rest.one('automail', id).one('textMessage', textMessage.id).customPUT(textMessage);
    };

    createEmail(id, email) {
        return this.rest.one('automail', id).all('email').post({ email: email });
    };

    createTextMessage(id, textMessage) {
        return this.rest.one('automail', id).all('textMessage').post(textMessage);
    };

    textMessageContent(id, textMessageId) {
        return this.rest.one('automail', id).one('textMessageContent', textMessageId).get();
    };
    
    getPlainContent(id, emailId) {
        return this.rest.one('automail', id).one('email', emailId).one('plainContent').get();   
    };
};

Automation.$inject = ['Rest'];
